module.exports = __webpack_public_path__ + "static/media/pd1CertLogo.af635081.png";